(function () {
    "use strict";

    class CompanySettingsBankComponent extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, uuid4, UsersManager, ModalService, $q, CompaniesManager, PopupMessageService,
                    StripeHelperService, AnalyticsService, FeaturesService, $translate, _, OnboardingService, UIUtils) {
            super($scope, $injector);
            this.__objectType = 'CompanySettingsBankController';

            this.ModalService = ModalService;
            this.$q = $q;
            this.CompaniesManager = CompaniesManager;
            this.PopupMessageService = PopupMessageService;
            this.AnalyticsService = AnalyticsService;
            this.StripeHelperService = StripeHelperService;
            this.$translate = $translate;
            this._ = _;
            this.OnboardingService = OnboardingService;
            this.UIUtils = UIUtils;

            AnalyticsService.trackPageView(this, 'bank settings screen');

            this.user = UsersManager.getCurrUser();
            this.company = this.user.company;
            this.stripePersons = this.user.company.stripe_persons || [];
            this.entityIdsBeingDeleted = {};

            // Instant Deposits

            this.debitCard = this.user.myDebitCard();
            this.bankAccount = this.user.myBankAccount();

            this.register(this.user, 'success', () => {
                this.bankAccount = this.user.myBankAccount();
                this.stripePersons = this.user.company.stripe_persons;
            });

            this.updateSubtitle();
        }

        showInstantDepositSection() {
            // note: eligible_for_instant_payouts is actually enough, left allow_instant_payouts to avoid reload
            return this.hasBankAccount() && (this.company.eligible_for_instant_payouts || this.company.allow_instant_payouts);
        }

        isOldBankAccount() {
            return this.bankAccount && !this.bankAccount.merchant_category_code && !this.bankAccount.doing_business_as_name && !this.bankAccount.url_product_description;
        }

        isPendingStripeMigration() {
            return !!this.company.pending_stripe_migration;
        }

        onAddOwnerClick() {
            this.AnalyticsService.trackClick(
                this,
                "add business owner",
                { currentOwnerCount: this.stripePersons.length}
            )
            this._showAddOwnerForm();
        }

        onOwnerEdit(owner) {
            this._showAddOwnerForm(owner);
        }

        onOwnerDelete(owner) {
            this.AnalyticsService.trackClick(this, "delete business owner");
            this._showDeleteConfirmation("COMPANY_SETTING.BANK_ACCOUNT._DELETE_OWNER_POPUP_TEXT_").then(() => {
                this.entityIdsBeingDeleted[owner._id] = true;
                this.CompaniesManager.deleteBankAccountOwner(this.user.company, owner._id).then(()  => {
                    delete this.entityIdsBeingDeleted[(owner || {})._id];
                });
                this.AnalyticsService.track(this, "business owner deleted");
            });
        }

        onBankAccountTypeSelected(type) {
            if (type === 'personal' && this.company.stripe_persons && this.company.stripe_persons.length > 1) {
                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info,
                    `You have listed ${this.company.stripe_persons.length} business owners, yet a personal bank account should have only one owner associated with it. Either remove other owners' info or select a business bank account to list more than one owner.`);
                return;
            }
            this.ModalService.openBankAccountBusinessInfoModal(type)
                .then(() => {
                    if (!this.stripePersons || !this.stripePersons.length) {
                        this._showAddOwnerForm(undefined, true);
                    }
                    this.bankAccount = this.user.myBankAccount();
                })
                .catch(() => 
                    this.AnalyticsService.trackCancel(
                        this,
                        "bank account modal"
                    )
                );
        }

        onBankAccountEdit(account) {
            const type = account.type === "Individual" ? "personal" : "business"; 
            this.ModalService.openBankAccountBusinessInfoModal(type);
        }

        onBankAccountDelete() {
            this.AnalyticsService.trackClick(this, "delete bank account");
            this._showDeleteConfirmation(
                "COMPANY_SETTING.BANK_ACCOUNT._DELETE_ACCOUNT_POPUP_TEXT_",
                {accountNumber: this.bankAccount.account_number_last4}
            ).then(() => {
                this.entityIdsBeingDeleted[this.bankAccount._id] = true;
                this.AnalyticsService.track(this, "bank account deleted");
                return this.user.deleteBankAccount(this.bankAccount)
                                .then(() => {
                                    delete this.entityIdsBeingDeleted[(this.bankAccount || {})._id];
                                    this.bankAccount = null;
                                });
            }).catch((resp) => {
            });

            this.updateSubtitle();
        }

        updateSubtitle() {
            if (this.bankAccount && this.isPendingStripeMigration()) {
                this.subtitle_text = "COMPANY_SETTING.BANK_ACCOUNT._PENDING_STRIPE_VERIFICATION_";
            } else {
                this.subtitle_text = this.isOldBankAccount() ?
                    "COMPANY_SETTING.BANK_ACCOUNT._NEW_STRIPE_SUBTITLE_" :
                    "COMPANY_SETTING.BANK_ACCOUNT._SUBTITLE_";
            }
        }

        hasBankAccount() {
            return !this._.isEmpty(this.bankAccount);
        }

        totalOwnershipPercentage() {
            return (this.stripePersons || []).reduce(
                (acc, person) => acc + person.ownership_percentage,
            0);
        }

        isTotalOwnershipFull() {
            return this.totalOwnershipPercentage() >= 100;
        }

        addOwnerTooltipText() {
            if (!this.hasBankAccount()) {
                return this.$translate.instant(
                    "COMPANY_SETTING.BANK_ACCOUNT._ADD_OWNER_DISLABED_TOOLTIP_TEXT_"
                );
            }

            if (this.bankAccount.type !== "Individual" && this.isTotalOwnershipFull()) {
                return this.$translate.instant(
                    "COMPANY_SETTING.BANK_ACCOUNT._FULL_OWNERSHIP_TOOLTIP_TEXT_"
                );
            }  
            
            return null;
        }

        // instant deposits

        onAddDebitCardClick() {
            this.ModalService.openAddDebitCardModal('companySettings')
                .then((resp) => {
                    this.debitCard = this.user.myDebitCard();

                }).catch((resp) => {

            });
        }

        deleteDebitCard() {
            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.delete_debit_card);
            this. _showDeleteConfirmation( 'COMPANY_SETTING.BANK_ACCOUNT._DELETE_ACCOUNT_POPUP_TEXT_',
               {accountNumber: this.debitCard.last4}).then(() => {
                this.user.deletePaymentMethod(this.debitCard._id).then(() => {
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.delete_debit_card);
                    this.debitCard = null;
                }).catch((e) => {
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.delete_debit_card, {error_message: e});

                });
           }).catch((e) => {
                this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.debit_card_delete_confirmation, {error_message: e});
            });
        }

        toggleInstantDeposit(e) {
            e.stopPropagation();
            if(this.instantDepositAllPayments) {
                console.log('turn instant deposits on for all payment');
            }
            else {
                console.log('turn instant deposits off for all payment');
                // what about payments that are already instant deposit? is it future only?
            }
        }

        isAddOwnerButtonDisabled() {
            return this.isTotalOwnershipFull() || !this.hasBankAccount();
        }

        _showAddOwnerForm(owner, fromBankAccountForm) {
            this.ModalService.openAddBankAccountOwnerModal(owner, fromBankAccountForm).then(() => {
                this.stripePersons = this.company.stripe_persons;
                this.OnboardingService.onBankAccountAdded();
            });
        }

        _showDeleteConfirmation(text, textParams = {}) {
            return this.PopupMessageService.showConfirmPromise(
                this.PopupMessageService.severityTypes.warning, this.$translate.instant(text, textParams)
            );
        }

        isBeingDeleted(entity) {
            if (!entity) {
                return false;
            }
            return !!this.entityIdsBeingDeleted[entity._id];
        }

        missingDetailsMessage() {
            if (this.isOldBankAccount() || (!this.bankAccount && this.stripePersons.length === 0)) {
                return false;
            }

            this.bankAccountMissing = this.bankAccount && this.bankAccount.fields_to_fix && this.bankAccount.fields_to_fix.length > 0;
            this.ownersMissing = this.stripePersons.filter(person => person.fields_to_fix && person.fields_to_fix.length > 0);
            this.ownersMissingById = this.ownersMissing.reduce((acc, owner) => {
                acc[owner._id] = true;
                return acc;
            }, {});

            if (!this.bankAccount) {
                return this.$translate.instant(
                    "COMPANY_SETTING.BANK_ACCOUNT._BANK_INFO_MISSING_"
                );
            }
            else if (!this.stripePersons || this.stripePersons.length === 0) {
                return this.$translate.instant(
                    "COMPANY_SETTING.BANK_ACCOUNT._OWNER_INFO_MISSING_"
                );
            }
            else if (this.bankAccountMissing && this.ownersMissing.length) {
                return this.$translate.instant(
                    "COMPANY_SETTING.BANK_ACCOUNT._BOTH_INFO_MISSING_"
                );
            } else if (this.bankAccountMissing) {
                return this.$translate.instant(
                    "COMPANY_SETTING.BANK_ACCOUNT._BANK_INFO_MISSING_"
                );
            } else if (this.ownersMissing.length) {
                return this.stripePersons.length > 1 ?
                    this.$translate.instant(
                        "COMPANY_SETTING.BANK_ACCOUNT._MULTI_OWNER_INFO_MISSING_",
                        {
                            names: this.UIUtils.joinListWithCommasAndApersand(
                                this.ownersMissing.map(owner => owner.full_name)
                            )
                        }
                    ) :
                    this.$translate.instant(
                        "COMPANY_SETTING.BANK_ACCOUNT._OWNER_INFO_MISSING_"
                    );

            }
        }
    }

    Components.CompanySettingsBank = {
        controller: CompanySettingsBankComponent,
        controllerAs: 'companySettingsBankVm',
        name: 'hbCompanySettingsBank',
        templateUrl: 'angular/app/modules/core/features/settings/company/bank/company_settings_bank_template.html'
    };

}());
